import { render, staticRenderFns } from "./man.vue?vue&type=template&id=30ab8d32&scoped=true&"
import script from "./man.vue?vue&type=script&lang=js&"
export * from "./man.vue?vue&type=script&lang=js&"
import style0 from "./man.vue?vue&type=style&index=0&id=30ab8d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab8d32",
  null
  
)

export default component.exports